import { render, staticRenderFns } from "./DGoogle.vue?vue&type=template&id=0aa648fa"
import script from "./DGoogle.vue?vue&type=script&lang=js"
export * from "./DGoogle.vue?vue&type=script&lang=js"
import style0 from "./DGoogle.vue?vue&type=style&index=0&id=0aa648fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports